import React from "react";

/**
 * Renders text clipped to `limit` characters with a "vezi tot" toggle.
 * Pure presentation — no effect on the underlying data.
 */
export default class TruncatedText extends React.Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }

  render() {
    const limit = this.props.limit || 90;
    const text = this.props.text || "";

    if (text.length <= limit) {
      return <span>{text}</span>;
    }

    const { expanded } = this.state;
    return (
      <span>
        {expanded ? text : text.slice(0, limit).trimEnd() + "…"}
        <button
          className="ds-link-btn ds-link-btn--inline"
          onClick={e => {
            e.stopPropagation();
            this.setState({ expanded: !expanded });
          }}
        >
          {expanded ? "mai putin" : "vezi tot"}
        </button>
      </span>
    );
  }
}
